import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';

const ProfileForm = (params) => {
  //const [reports, setReports] = useState({data:[]});
  var info = params.info;
  const [reportsBU, setReportsBU] = useState({data:[]});
  const [company, setCompany] = useState([]);
  //const [info, setInfo] = useState(params.info);
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})
  const [erroRequiredBU, setErroRequiredBU] = useState({campos:[],erro:false})

  const [bus, setBus] = useState([]);

  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState(null);
  const [formChangesBU, setFormChangesBU] = useState([]);
  const [wasModified, setWasModified] = useState(false);

  const model = {
    company_id: localStorage.getItem('companyId'),
    sumo_bu_id: null,
  };

  var reports = params.reports;
  var setReports = params.setReports;

  useEffect(() => {
      // let info = ResalesRequestService.getInfoResale();
      // info.then(data => {
      //   setInfo(data.data);
      // })
      // let company = ResalesRequestService.getResale(localStorage.getItem('companyId'));
      // company
      // .then(data => {
      //   data.data[0].vip = data.data[0].vip?data.data[0].vip:0;
      //   data.data[0].sumo_status = data.data[0].sumo_status?data.data[0].sumo_status:0;
      //   setReports(data);
      // });
      let bus = ResalesRequestService.getResaleBUs(localStorage.getItem('companyId'));
      bus.then(data => {
        setReportsBU(data);
      });
  }, []);

  useEffect(() => {
    setCompany(reports.data[0]);
    if(reports.data[0] != null && formChanges === null){
      setFormChanges({ ...reports.data[0] });
    }
  }, [reports,formEdit,wasModified,formChanges,erroRequired]);

  useEffect(() => {
    setBus(reportsBU.data);
    let changes = reportsBU.data.map(v=>{
      return {...v};
    });
    if(changes.length === 0){
      changes.push({...model});
    }
    setFormChangesBU(changes);
    
  }, [reportsBU,formEdit]);

  useEffect(()=>{
    let tamanho = formChangesBU.length>bus.length?formChangesBU.length:bus.length;
    
    var retorno = false;
    for (let i = 0; i < tamanho; i++) {
      Object.keys(model).map((v)=>{
        try {
          var v1 = bus[i][v]?bus[i][v]:'';
        } catch (error) {
          var v1 = v==='company_id'?localStorage.getItem('companyId'):'';
        }
        try {
          var v2 = formChangesBU[i][v]?formChangesBU[i][v]:'';
        } catch (error) {
          var v2 = v==='company_id'?localStorage.getItem('companyId'):'';
        }
        if(v2 != v1){
          retorno = true;
        }
      })
      if(retorno){
        break;
      }
    }
    setWasModified(retorno);
  },[formChangesBU,erroRequiredBU]);

  const verificarRequired = (k,name) => {
    var retorno = false;
    erroRequiredBU.campos.map(campo=>{
      
      if(campo.campo === name && campo.indice === k)
        retorno = true;
    });
    
    return retorno;
  }

  const removerRequired = (k,name) => {
    erroRequiredBU.campos.map((campo,i)=>{
      if(campo.campo === name && campo.indice === k)
      erroRequiredBU.campos.splice(i, 1);
    })
  }

  const verificarAlteracoes = (value,attributeName) => {
    const index = erroRequired.campos.indexOf(attributeName);
    if (index > -1) {
      erroRequired.campos.splice(index, 1);
    }
    var changes = { ...formChanges };
    changes[attributeName] = value;
    
    var retorno = false;
    Object.keys(company).map((v)=>{
      var v1 = company[v]?company[v]:'';
      var v2 = changes[v]?changes[v]:'';
      if(v2 != v1){
        retorno = true;
      }
    })
    setWasModified(retorno);
    setFormChanges(changes);
  };

  const verificarAlteracoesBU = (index,value,attributeName) => {
    removerRequired(index,attributeName);

    var changes = [...formChangesBU];
    changes[index][attributeName] = value;
    setFormChangesBU(changes);
  };

  const saveCompany = ()=>{
    while(erroRequired.campos.length) {
      erroRequired.campos.pop();
    }
    erroRequired.erro= false;
    let camposObrigatorios = ['segment_id','client_type_id'];
    let required = {campos:[],erro:false};
    camposObrigatorios.map(v=>{
      if(formChanges[v] === null || formChanges[v] === "" || formChanges[v] === 0){
        required.campos.push(v);
        required.erro = true;
      }
    });
    setErroRequired(required);
    if(!required.erro){
      if(saveBus()){
        let company = ResalesRequestService.saveResale(localStorage.getItem('companyId'),{ params: { ...formChanges } });
        company.then(data => {
          setReports(data);
          setFormEdit(false);
          setWasModified(false);
        });
      }
    }
  };

  const saveBus = ()=>{
    while(erroRequiredBU.campos.length) {
      erroRequiredBU.campos.pop();
    }
    erroRequiredBU.erro= false;
    // verificar required
    let camposObrigatorios = ['sumo_bu_id'];
    let required = {...erroRequiredBU};
    formChangesBU.map((bu,k)=>{
      camposObrigatorios.map(v=>{
        if(bu[v] === null || bu[v] === "" || bu[v] === 0){
          let obj = {indice:k,campo:v};
          required.campos.push(obj);
          required.erro = true;
        }
      });
    });
    setErroRequiredBU(required);
    if(!required.erro){
      let bus_params = {
        insert:[],
        update:[],
        delete:[]
      };
      formChangesBU.map(contact=>{
        //verificar se nao esta vazio
        let vazio = true;
        Object.keys(model).map(k=>{
          if(k!='company_id'){
            if(contact[k]!='')
            vazio = false;
          }
        });

        if(!vazio){
          if(contact.id!=null){
            let iguais = true;
            let c2 = {id:contact.id};
            bus.map(c=>{
              if(c.id === contact.id)
                Object.keys(model).map(k=>{
                  if(k!='company_id'){
                    if(contact[k]!=c[k]){
                      iguais = false;
                      c2[k] = contact[k];
                    }
                  }
                });
            });
            if(!iguais)
            bus_params.update.push(c2);
          }else{
            bus_params.insert.push(contact);
          }
        }
      });
      bus.map(c1=>{
        let existe = false;
        formChangesBU.map(c2=>{
          if(c1.id === c2.id){
            existe = true;
          }
        })
        if(!existe)
        bus_params.delete.push(c1);      
      });
      let save = ResalesRequestService.updateResaleBUs(
        localStorage.getItem('companyId'),
        { params: { ...bus_params } }
      );
      save.then(data => {
        setReportsBU(data);
        setFormEdit(false);
        setWasModified(false);
      });
      return true;
    }
    return false;
  };

  const createCardForm = (k,contact) => {
    return(
      <Col xs={4} key={k}>
        <Card className="m-2">
          <Card.Body>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>BU Secundario</Form.Label>
                  <Form.Control
                    className={verificarRequired(k,'sumo_bu_id')?'border-danger':''}
                    as="select"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoesBU(k,e.target.value,'sumo_bu_id')}
                    value={getValueBU(k,'sumo_bu_id')}
                    >
                      <option value='' disabled>Selecione</option>
                    {info.bu.map(bu=>{
                      return(<option value={bu.id}>{bu.name}</option>)
                    })}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
              {formEdit?(
                    <Button style={{marginRight:"5px"}}
                      variant="danger"
                      onClick={()=>{
                        let change = [...formChangesBU];
                        if(change[k].id != null){
                          setWasModified(true);
                        } else {

                        }
                        change.splice(k, 1);
                        setFormChangesBU(change);
                      }}>Remover</Button>
                  ):(<></>)}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    );
  };

  const getLista = () => {
    if(!formEdit){
      return bus;
    } else {
      return formChangesBU;
    }
  };

  const getValue = (attributeName)=>{
    if(!formEdit){
      return company[attributeName]?company[attributeName]:'';
    } else {
      return formChanges[attributeName]?formChanges[attributeName]:'';
    }
  };

  const getValueBU = (index,attributeName)=>{
    if(!formEdit){
      if(bus.length>0)
      return bus[index][attributeName]?bus[index][attributeName]:'';
      else return '';
    } else {
      return formChangesBU[index][attributeName]?formChangesBU[index][attributeName]:'';
    }
  };

  return (
    <Card key={'profile-form'}>
      <Card.Body>
        <Container>
          <Row>
            <Col>
              <p  className="font-weight-bold">Perfil</p>
            </Col>
            <Col className="d-flex justify-content-end">
              {formEdit?(
              <>
                <Button style={{marginRight:"5px"}}
                  variant="success"
                  disabled={!wasModified}
                  title={!wasModified?'Não houve alterações':''}
                  onClick={()=>{
                    saveCompany();
                  }}>Salvar</Button>
                <Button style={{marginRight:"5px"}}
                  variant="danger"
                  onClick={()=>{
                    setFormEdit(false);
                    setFormChanges({ ...reports.data[0] });
                    setErroRequired({campos:[],erro:false})
                    setErroRequiredBU({campos:[],erro:false})
                  }}>Cancelar</Button>
              </>
              ):(<></>)}
              <Button
                disabled={formEdit}
                onClick={()=>{
                setFormEdit(true);
              }}>{formEdit?'Editando':'Editar'}</Button>
            </Col>
          </Row>         
          <Row>
            <Col xs={3}>
              <Form.Group>
                <Form.Label>Segmento:</Form.Label>
                <Form.Control
                  className={erroRequired.campos.includes('segment_id')?'border-danger':''}
                  as="select"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(e.target.value,'segment_id')}
                  value={getValue('segment_id')}
                  >
                  <option value='' disabled={true}>Selecione</option>
                  {Object.values(info.segment).map((v,key)=>{
                    return(<option value={v.id} key={key}>{v.name}</option>);
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group>
                <Form.Label>Tipo de Cliente:</Form.Label>
                <Form.Control
                  className={erroRequired.campos.includes('client_type_id')?'border-danger':''}
                  as="select"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(e.target.value,'client_type_id')}
                  value={getValue('client_type_id')}
                  >
                  <option value='' disabled={true}>Selecione</option>
                  {Object.values(info.client_type).map(v=>{
                    return(<option value={v.id}>{v.name}</option>);
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group>
                <Form.Label>BU Primario:</Form.Label>
                <Form.Control
                  className={verificarRequired(0,'sumo_bu_id')?'border-danger':''}
                  as="select"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoesBU(0,e.target.value,'sumo_bu_id')}
                  value={getValueBU(0,'sumo_bu_id')}
                  >
                    <option value='' disabled>Selecione</option>
                  {info.bu.map((bu,key)=>{
                    return(<option value={bu.id} key={key}>{bu.name}</option>)
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group>
                <Form.Label>Outros:</Form.Label>
                <Form.Check 
                label="ELITE VIP"
                disabled={company.premium===1?!formEdit:true}
                onChange={e=>company.premium===1?verificarAlteracoes(e.target.checked,'vip'):()=>{}}
                checked={getValue('vip')}></Form.Check>

                <Form.Check 
                label="Ativo"
                disabled={!formEdit}
                onChange={e=>verificarAlteracoes(e.target.checked,'sumo_status')}
                checked={getValue('sumo_status')}></Form.Check>
              </Form.Group>
            </Col>
          </Row> 
          <Row className="m-2">
            <Col className="d-flex">
            {formEdit?(
                  <Button
                    variant="secondary"
                    onClick={()=>{
                      let change = [...formChangesBU];
                      change.push({...model});
                      setFormChangesBU(change);
                    }}>Adicionar BU</Button>
                ):(<></>)}
            </Col>
          </Row>
          <Row>
            {getLista().map((c,k) =>{
              if(k===0){
                return(<></>);
              }
              return (<>
                {createCardForm(k,c)}
                </>);
            })}
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};

export default ProfileForm;